if (!customElements.get('product-card-buy-now')) {
  customElements.define('product-card-buy-now', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-card-buy-now]');
      this.paymentContainer = this.querySelector('[data-card-native-payment]');
      this.handleClickBound ||= this.handleClick.bind(this);
      this.addEventListener('click', this.handleClickBound);
      this.resetLoadingBound ||= this.resetLoading.bind(this);
      window.addEventListener('pageshow', this.resetLoadingBound);
      // 原生入口异步加载或状态变化时同步按钮，不轮询、不跨卡片查找。
      if (this.paymentContainer) {
        this.observer = new MutationObserver(() => this.syncAvailability());
        this.observer.observe(this.paymentContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled'],
        });
      }
      this.syncAvailability();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickBound);
      this.observer?.disconnect();
      window.removeEventListener('pageshow', this.resetLoadingBound);
      clearTimeout(this.loadingTimeout);
      this.setLoading(false);
    }

    syncAvailability() {
      this.nativeButton = this.paymentContainer?.querySelector('.shopify-payment-button__more-options');
      const available = this.dataset.available === 'true' && this.nativeButton &&
        !this.nativeButton.disabled && this.nativeButton.getAttribute('aria-disabled') !== 'true';
      if (this.button) {
        this.button.disabled = Boolean(this.loading) || !available;
        this.button.setAttribute('aria-disabled', String(this.button.disabled));
      }
    }

    setLoading(loading) {
      this.loading = loading;
      this.button?.classList.toggle('loading', loading);
      this.button?.setAttribute('aria-busy', String(loading));
      this.syncAvailability();
    }

    resetLoading() {
      clearTimeout(this.loadingTimeout);
      this.setLoading(false);
    }

    handleClick(event) {
      const button = event.target.closest('[data-card-buy-now]');
      if (!button || button !== this.button) return;
      event.preventDefault();
      this.syncAvailability();
      if (button.disabled) return;

      // 不提供加购或跳转回退，原生入口不可用时仅置灰。
      this.setLoading(true);
      // 原生支付不提供完成回调，超时后恢复重试；返回页面时也清除等待状态。
      this.loadingTimeout = setTimeout(() => this.resetLoading(), 20000);
      try {
        this.nativeButton.click();
      } catch (error) {
        this.resetLoading();
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        console.warn('Native checkout unavailable.', error);
      }
    }
  });
}
